import classnames from 'classnames'
import React, { PropsWithChildren } from 'react'
import Slider from 'react-slick'
import { useMediaQuery } from '../../hooks/useMediaQuery'
import { CustomLink } from '../CustomLink'
import { Grid } from '../Grid'
import { IData } from '../ListingCard/variables'
import classes from './similarProjectsGrid.module.scss'

const ResponsiveProjects: React.FC<PropsWithChildren<{data: IData[]}>> = ({ data }) => {
  const isTablet = useMediaQuery('(max-width: 1024px)')
  const isMobile = useMediaQuery('(max-width: 767px)')

  return (
    <div className={classes.respSlider}>
      <div className={classes.carousel__container}>
        <Grid style={{ display: 'flex', justifyContent: 'center' }}><h2>Similar projects</h2></Grid>
        <Slider
          centerMode
          centerPadding={isTablet ? '10%' : '20%'}
          className={classnames(classes['carousel_slider'], classes[`posts-${data.length}`])}
          arrows={false}
          slidesToShow={isMobile ? 1 : 2}
        >
          {
            data.map((item: IData, idx: number) => item && (
              <div key={idx} className={classes.cardContainer}>
                <a href={item?.url}>
                  <img src={item?.image} alt="" className={classes.cardImage} />
                </a>
                <p className={classes.cardHeader}>{item?.brand}</p>
                <p className={classes.cardSubtitle}>{item?.description}</p>
              </div>
            ))
          }
        </Slider>
        <div className={classes.buttonContainer} >
          <CustomLink
            href={'/projects'}
            variant={'primary-with-arrow'}
          >
          View all case studies
          </CustomLink>
        </div>
      </div>
    </div>
  )
}

export default ResponsiveProjects
